import React, {useState} from "react";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import {getCardIcon} from "../../../utils/utils"
import PublicEmployeeTable from "./PublicEmployeeTable/PublicEmployeeTable";
import PublicEmployeeInternalDatabaseTable from "./PublicEmployeeTable/PublicEmployeeInternalDatabaseTable";

function PublicEmployeeCard(props) {

    const [expanded, setExpanded] = useState(false);
    const [firstTime, setFirstTime] = useState(true);

    const {public_employee} = props

    let initialExpand = public_employee.flag === "positive"? false : true
    if (initialExpand !== expanded && firstTime===true){
        setExpanded(initialExpand);
    }
    const handleExpand = (event) => {
        event.stopPropagation();
        setFirstTime(false)
        setExpanded(!expanded);
    };

    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
                <div 
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    Servidor Público
                </div>
                <div style={{margin:"auto 10px"}}>
                    {getCardIcon(public_employee.flag)}
                </div>
                {(public_employee.data.length===0||public_employee.data[0]["is_public_employee"]===false)? null :
                <IconButton style={{marginLeft: "auto"}} onClick={handleExpand}>
                    {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>             
                }                    
            </div>
            {public_employee.data.length===0||public_employee.data[0]["is_public_employee"] === false ? null :
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <div 
                    className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
                >
                {
                  public_employee.data[0].provider === "internal_database"
                    ? <PublicEmployeeInternalDatabaseTable public_employee_data={public_employee.data} />
                    : <PublicEmployeeTable public_employee_data={public_employee.data} />
                }
                </div>
            </Collapse> 
            }     
        </div>
        );
}

export default PublicEmployeeCard